import i18next from 'i18next';

import authRoles from '../../auth/authRoles';
import ru from '../navigation-i18n/ru';
import uz from '../navigation-i18n/uz';

i18next.addResourceBundle('uz', 'navigation', uz);
i18next.addResourceBundle('ru', 'navigation', ru);

const navigationConfig = [
  {
    id: 'apps',
    title: 'Applications',
    type: 'group',
    auth: authRoles.user,
    icon: 'react-outline:home',
    translate: 'Basic',
    children: [
      {
        id: 'apps.home',
        title: 'HomePage',
        type: 'item',
        icon: 'react-outline:home',
        url: '/',
        translate: 'Main',
      },
      {
        id: 'myuzinfocom',
        title: 'MyUzinfocom',
        type: 'collapse',
        icon: 'react-outline:building-office-2',
        translate: 'MyUzinfocom',
        auth: authRoles.user,
        children: [
          {
            id: 'apps.structure',
            title: 'Structure',
            type: 'item',
            icon: 'react-outline:collection',
            url: '/apps/org-structure',
            translate: 'Structure',
          },
          {
            id: 'apps.staff',
            title: 'Staff',
            type: 'item',
            icon: 'react-outline:user-group',
            url: '/apps/staff',
            translate: 'Staff',
          },
          {
            id: 'apps.culture',
            title: 'Values',
            type: 'item',
            icon: 'material-outline:auto_awesome',
            url: '/apps/culture',
            translate: 'Values',
          },
        ],
      },
      {
        id: 'apps.chat',
        title: 'Chat',
        type: 'item',
        auth: authRoles.user,
        icon: 'react-outline:chat-alt',
        url: '/apps/chat',
        translate: 'Chat',
        permissionKey: 'chat-page',
      },
      {
        id: 'apps.video-conferences',
        title: 'VideoConferences',
        type: 'item',
        auth: authRoles.user,
        icon: 'react-outline:video-camera',
        url: '/apps/video-conferences',
        translate: 'VideoConferences',
      },
    ],
  },
  {
    id: 'work',
    title: 'Work',
    type: 'group',
    auth: authRoles.user,
    icon: 'react-outline:home',
    translate: 'Work',
    children: [
      {
        id: 'apps.projects-management',
        title: 'Projects Management',
        type: 'collapse',
        auth: authRoles.user,
        icon: 'react-outline:view-boards',
        translate: 'ProjectsManagement',
        children: [
          {
            id: 'apps.projects',
            title: 'Projects Management',
            type: 'item',
            icon: 'react-outline:view-boards',
            url: '/apps/projects',
            translate: 'Projects',
            end: true,
          },
          {
            id: 'apps.projects-dashboard',
            title: 'Projects dashboard',
            type: 'item',
            auth: authRoles.top,
            icon: 'react-outline:chart-pie',
            url: '/apps/projects-dashboard',
            translate: 'Dashboard',
            end: true,
          },
        ],
      },
      {
        id: 'internal-workflow',
        title: 'documents',
        type: 'collapse',
        icon: 'react-outline:document-text',
        translate: 'InternalWorkflow',
        auth: authRoles.employee,
        children: [
          {
            id: 'apps.create-document',
            title: 'CreateDocument',
            type: 'item',
            auth: authRoles.user,
            icon: 'react-outline:document-plus',
            url: '/apps/documents-2/create-document',
            translate: 'CreateDocument',
          },
          {
            id: 'apps.incoming-document',
            title: 'IncomingDocuments',
            type: 'item',
            auth: authRoles.user,
            icon: 'react-outline:incoming-document',
            url: '/apps/documents-2/incoming-document',
            translate: 'IncomingDocuments',
          },
          {
            id: 'apps.outgoing-document',
            title: 'OutgoingDocuments',
            type: 'item',
            auth: authRoles.user,
            icon: 'react-outline:outgoing-document',
            url: '/apps/documents-2/outgoing-document',
            translate: 'OutgoingDocuments',
          },
          {
            id: 'apps.archive',
            title: 'Archive',
            type: 'item',
            auth: authRoles.user,
            icon: 'react-outline:archive',
            url: '/apps/documents-2/archive',
            translate: 'Archive',
          },
          {
            id: 'apps.local-normative-acts',
            title: 'LocalNormativeActs',
            type: 'item',
            icon: 'react-outline:document-text',
            url: '/apps/local-normative-acts',
            translate: 'LocalNormativeActs',
            end: true,
          },
          {
            id: 'apps.templates-management',
            title: 'TemplatesManagement',
            type: 'item',
            icon: 'react-outline:templates-management',
            auth: authRoles.hr,
            url: '/apps/templates-management',
            translate: 'TemplatesManagement',
            end: true,
          },
          {
            id: 'apps.blank',
            title: 'Blanks',
            type: 'item',
            icon: 'react-outline:document',
            url: '/apps/blanks',
            translate: 'Blanks',
          },
          {
            id: 'apps.presentation',
            title: 'Presentation',
            type: 'item',
            icon: 'react-outline:presentation-chart-bar',
            url: '/apps/presentation',
            translate: 'Presentations',
          },
          {
            id: 'apps.internal-documents',
            title: 'InternalDocuments',
            type: 'item',
            icon: 'react-outline:document-text',
            url: '/apps/internal-documents',
            translate: 'InternalDocuments',
          },
        ],
      },
      {
        id: 'apps.calendar',
        title: 'Calendar',
        type: 'collapse',
        icon: 'react-outline:calendar',
        auth: authRoles.user,
        translate: 'Calendar',
        children: [
          {
            id: 'resources-calendar',
            title: 'Resources calendar',
            type: 'item',
            url: 'apps/calendar/resources',
            icon: 'react-outline:calendar',
            translate: 'Reservation',
          },
          {
            id: 'my-calendar',
            title: 'My calendar',
            type: 'item',
            icon: 'react-outline:calendar',
            url: 'apps/calendar/my',
            translate: 'MyCalendar',
          },
          {
            id: 'apps.my-calendar',
            title: 'MyCalendar',
            type: 'item',
            icon: 'react-outline:calendar',
            url: '/apps/my-calendar',
            translate: 'MyCalendarBeta',
            auth: authRoles.tester,
          },
        ],
      },
      {
        id: 'hr',
        title: 'HR',
        type: 'collapse',
        icon: 'react-outline:users',
        translate: 'HumanResources',
        auth: authRoles.hr,
        children: [
          {
            id: 'departments',
            title: 'Departments',
            icon: 'react-outline:view-list',
            translate: 'Departments',
            type: 'item',
            url: 'hr/departments',
          },
          {
            id: 'users',
            title: 'Users',
            icon: 'react-outline:user-group',
            type: 'item',
            url: 'hr/users',
            translate: 'Users',
          },
          {
            id: 'staff-table',
            title: 'Staffing table',
            icon: 'react-outline:table',
            type: 'item',
            url: 'hr/staff-table',
            translate: 'StaffTable',
          },
        ],
      },
      {
        id: 'admin',
        title: 'Administration',
        type: 'collapse',
        auth: authRoles.admin,
        icon: 'react-outline:cog',
        translate: 'Administration',
        children: [
          {
            id: 'apps.roles',
            title: 'Roles',
            type: 'item',
            icon: 'settings_input_component',
            url: 'admin/roles',
            translate: 'Roles',
          },
          {
            id: 'apps.users',
            title: 'Users',
            type: 'item',
            icon: 'react-outline:user-group',
            url: 'admin/users',
            translate: 'Users',
            end: true,
          },
          {
            id: 'hrm-employees',
            title: 'Users',
            icon: 'react-outline:user-group',
            type: 'item',
            url: 'admin/hrm-employees',
            translate: 'Employees',
          },
          {
            id: 'top-managers',
            title: 'Top managers',
            icon: 'react-outline:user',
            type: 'item',
            url: 'admin/top-managers',
            translate: 'TopManagers',
          },
          {
            id: 'apps.references',
            title: 'References',
            type: 'item',
            icon: 'react-outline:view-list',
            url: 'admin/references/translations',
            translate: 'References',
            end: true,
          },
          {
            id: 'apps.skills',
            title: 'Skills',
            type: 'item',
            icon: 'material-outline:auto_fix_high',
            url: 'admin/skills',
            translate: 'Skills',
            end: true,
          },
          {
            id: 'apps.claimexecutors',
            title: 'ClaimExecutors',
            type: 'item',
            icon: 'react-outline:flag',
            url: 'admin/claimexecutors',
            translate: 'ClaimExecutors',
            end: true,
          },
          {
            id: 'apps.documentexecutors',
            title: 'DocumentExecutors',
            type: 'item',
            icon: 'react-outline:document-check',
            url: 'admin/document-template-executors',
            translate: 'DocumentExecutors',
            end: true,
          },
          // {
          //   id: 'apps.crudMap',
          //   title: 'Maps',
          //   type: 'item',
          //   icon: 'react-outline:map',
          //   url: 'admin/crud-map',
          //   translate: 'Maps',
          //   end: true,
          // },
          {
            id: 'apps.logs',
            title: 'Logs',
            type: 'item',
            icon: 'react-outline:document-text',
            url: 'admin/logs',
            translate: 'Logs',
            end: true,
          },
        ],
      },
      {
        id: 'apps.service-desk',
        title: 'Service Desk',
        type: 'collapse',
        auth: authRoles.admin,
        icon: 'react-outline:shield-check',
        translate: 'ServiceDesk',
        children: [
          {
            id: 'apps.claims-processing',
            title: 'Claims Processing',
            type: 'item',
            icon: 'react-outline:clipboard',
            url: '/apps/claims-processing',
            translate: 'ClaimsProcessing',
          },
          {
            id: 'apps.service-desk',
            title: 'Service Desk',
            type: 'item',
            icon: 'react-outline:shield-check',
            url: '/apps/service-desk',
            translate: 'ServiceDesk',
          },
        ],
      },
    ],
  },
  {
    id: 'useful',
    title: 'Useful',
    type: 'group',
    auth: authRoles.user,
    icon: 'react-outline:home',
    translate: 'Useful',
    children: [
      {
        id: 'apps.profile',
        title: 'Profile',
        type: 'item',
        icon: 'react-outline:user-circle',
        url: '/apps/profile',
        translate: 'Profile',
      },
      {
        id: 'apps.mydrive',
        title: 'MyDrive',
        type: 'item',
        icon: 'react-outline:folder',
        url: '/apps/my-drive',
        translate: 'MyDrive',
        auth: authRoles.employee,
      },
      {
        id: 'apps.appointments',
        title: 'Appointment',
        type: 'item',
        icon: 'react-outline:briefcase',
        url: '/apps/appointments',
        translate: 'Appointments',
      },
      {
        id: 'apps.skud',
        title: 'Skud',
        type: 'collapse',
        auth: authRoles.manager,
        icon: 'react-outline:users',
        translate: 'SkudEmployees',
        children: [
          {
            id: 'skud-departments',
            title: 'Employees',
            type: 'item',
            icon: 'react-outline:clock',
            url: 'apps/skud/departments',
            translate: 'Skud',
            end: true,
          },
          {
            id: 'daily-attendances',
            title: 'Daily attendances',
            type: 'item',
            icon: 'react-outline:calendar',
            url: 'apps/skud/daily-attendances',
            translate: 'DailyAttendances',
            end: true,
          },
          {
            id: 'absence-asks',
            title: 'Absence asks',
            type: 'item',
            icon: 'react-outline:arrow-right-start-on-rectangle',
            url: 'apps/skud/absence-asks',
            translate: 'AbsenceAsks',
            end: true,
          },
          {
            id: 'workload',
            title: 'Workload',
            type: 'item',
            icon: 'react-outline:scale',
            url: 'apps/skud/workload',
            translate: 'Workload',
            end: true,
          },
          // {
          //   id: 'skud-report',
          //   title: 'Report',
          //   type: 'item',
          //   auth: authRoles.top,
          //   icon: 'react-outline:document-chart-bar',
          //   url: 'apps/skud/report',
          //   translate: 'SkudReport',
          //   end: true,
          // },
          // {
          //   id: 'skud-departments-report',
          //   title: 'DepartmentsReport',
          //   type: 'item',
          //   icon: 'react-outline:clock',
          //   url: 'apps/skud/departments-report',
          //   translate: 'DepartmentsReport',
          //   end: true,
          // },
          // {
          //   id: 'skud-blocks-daily-report',
          //   title: 'SkudBlocksDailyReport',
          //   type: 'item',
          //   auth: authRoles.top,
          //   icon: 'react-outline:calendar',
          //   url: 'apps/skud/blocks-daily-report',
          //   translate: 'BlocksDailyReport',
          //   end: true,
          // },
          {
            id: 'attendace-report',
            title: 'AttendanceReport',
            type: 'item',
            icon: 'react-outline:document-text',
            url: 'apps/skud/attendance-report',
            translate: 'AttendanceReport',
            end: true,
          },
          {
            id: 'attendace-report-top',
            title: 'AttendaceReportTop',
            type: 'item',
            icon: 'react-outline:document-text',
            url: 'apps/skud/attendance-report-top',
            translate: 'AttendaceReportTop',
            auth: authRoles.CEO,
            end: true,
          },
        ],
      },
      {
        id: 'app-skud-departments-report',
        title: 'DepartmentsReport',
        type: 'item',
        icon: 'react-outline:clock',
        url: 'apps/skud-departments-report',
        translate: 'DepartmentsReport',
        auth: authRoles.AttendanceReportAll,
      },
      // {
      //   id: 'documents',
      //   title: 'documents',
      //   type: 'collapse',
      //   icon: 'react-outline:document-text',
      //   translate: 'InternalWorkflow',
      //   auth: authRoles.employee,
      //   children: [
      //     {
      //       id: 'apps.incoming-documents',
      //       title: 'IncomingDocuments',
      //       type: 'collapse',
      //       auth: authRoles.user,
      //       icon: 'react-outline:document-text',
      //       translate: 'IncomingDocuments',
      //       children: [
      //         {
      //           id: 'apps.on-signing-documents',
      //           title: 'PendingSignature',
      //           type: 'item',
      //           icon: 'react-outline:document-text',
      //           url: '/apps/documents/on-signing',
      //           translate: 'PendingSignature',
      //         },
      //         {
      //           id: 'apps.signed-documents',
      //           title: 'Signed',
      //           type: 'item',
      //           icon: 'react-outline:document-text',
      //           url: '/apps/documents/signed',
      //           translate: 'Signed',
      //         },
      //         {
      //           id: 'apps.rejected-documents',
      //           title: 'Rejected',
      //           type: 'item',
      //           icon: 'react-outline:document-text',
      //           url: '/apps/documents/rejected',
      //           translate: 'Rejected',
      //         },
      //         {
      //           id: 'apps.in-execution-documents',
      //           title: 'InExecution',
      //           type: 'item',
      //           icon: 'react-outline:document-text',
      //           url: '/apps/documents/in-execution',
      //           translate: 'InExecution',
      //         },
      //         {
      //           id: 'apps.executed-documents',
      //           title: 'Fulfilled',
      //           type: 'item',
      //           icon: 'react-outline:document-text',
      //           url: '/apps/documents/completed',
      //           translate: 'Fulfilled',
      //         },
      //         {
      //           id: 'apps.archived-documents',
      //           title: 'Archived',
      //           type: 'item',
      //           icon: 'react-outline:document-text',
      //           url: '/apps/documents/archived',
      //           translate: 'Archive',
      //         },
      //       ],
      //     },
      //     {
      //       id: 'apps.documents',
      //       title: 'MyApplications',
      //       type: 'item',
      //       icon: 'react-outline:document-arrow-down',
      //       url: '/apps/documents/my-applications',
      //       translate: 'MyApplications',
      //       end: true,
      //     },
      //     {
      //       id: 'apps.blank',
      //       title: 'Blanks',
      //       type: 'item',
      //       icon: 'react-outline:document',
      //       url: '/apps/blanks',
      //       translate: 'Blanks',
      //     },
      //     {
      //       id: 'apps.presentation',
      //       title: 'Presentation',
      //       type: 'item',
      //       icon: 'react-outline:presentation-chart-bar',
      //       url: '/apps/presentation',
      //       translate: 'Presentations',
      //     },
      //     {
      //       id: 'apps.internal-documents',
      //       title: 'InternalDocuments',
      //       type: 'item',
      //       icon: 'react-outline:document-text',
      //       url: '/apps/internal-documents',
      //       translate: 'InternalDocuments',
      //     },
      //     {
      //       id: 'apps.local-normative-acts',
      //       title: 'LocalNormativeActs',
      //       type: 'item',
      //       icon: 'react-outline:document-text',
      //       url: '/apps/local-normative-acts',
      //       translate: 'LocalNormativeActs',
      //       end: true,
      //     },
      //     {
      //       id: 'apps.templates-management',
      //       title: 'TemplatesManagement',
      //       type: 'item',
      //       icon: 'material-outline:grading',
      //       auth: authRoles.hr,
      //       url: '/apps/templates-management',
      //       translate: 'TemplatesManagement',
      //       end: true,
      //     },
      //     {
      //       id: 'apps.document-checking',
      //       title: 'DocumentChecking',
      //       type: 'item',
      //       icon: 'material-outline:find_in_page',
      //       url: '/apps/documents/checking',
      //       translate: 'DocumentChecking',
      //       end: true,
      //     },
      //   ],
      // },
      {
        id: 'useful-links',
        title: 'UsefulLinks',
        type: 'collapse',
        icon: 'react-outline:globe-alt',
        auth: authRoles.user,
        translate: 'UsefulLinks',
        children: [
          {
            id: 'OldPortal',
            title: 'OldPortal',
            type: 'link',
            url: 'https://portal.uzinfocom.uz',
            translate: 'portal.uzinfocom.uz',
          },
          {
            id: 'ElectronMail',
            title: 'ElectronMail',
            type: 'link',
            url: 'https://mail.uzinfocom.uz',
            translate: 'mail.uzinfocom.uz',
          },
          {
            id: 'LMS',
            title: 'LMS',
            type: 'link',
            url: `${process.env.REACT_APP_BASE_FILE_URL}lms`,
            translate: 'LMS',
          },
          {
            id: 'EIjro',
            title: 'EIjro',
            type: 'link',
            url: 'https://edo.ijro.uz/welcome',
            translate: 'edo.ijro.uz',
          },
        ],
      },

      {
        id: 'apps.helpcenter',
        title: 'HelpCenter',
        type: 'collapse',
        icon: 'react-outline:question-mark-circle',
        translate: 'HelpCenter',
        auth: authRoles.user,
        children: [
          {
            id: 'helpdesk',
            title: 'HelpDesk',
            type: 'item',
            icon: 'react-outline:phone',
            url: '/apps/helpdesk',
            translate: 'HelpDesk',
          },
          {
            id: 'support',
            title: 'Claims',
            type: 'item',
            icon: 'react-outline:document-text',
            url: '/apps/support',
            translate: 'Claims',
          },
          {
            id: 'download-app',
            title: 'Feedback',
            type: 'item',
            icon: 'react-outline:archive-box-arrow-down',
            url: '/apps/download-app',
            translate: 'DownloadApp',
          },
        ],
      },
    ],
  },
];

export default navigationConfig;
